<template>
  <CContainer class="d-flex align-items-center min-vh-100">
    <CRow class="w-100">
      <CCol md="6">
        <div class="clearfix">
         <CInput label="Website Url" v-model="fields_data.website_address" />
         <CInput label="Database Url" v-model="fields_data.api_address" />
         <CInput label="Language" v-model="fields_data.language" />
         <CInput label="Language Fallback" v-model="fields_data.language_fallback" />
         <CInput label="Footer Text Right" v-model="fields_data.footer_text_right" />
         <CInput label="Footer Text Left" v-model="fields_data.footer_text_left" />
         <CInput label="Footer Image" v-model="fields_data.footer_image" />

         <CInputCheckbox label="Multiple Language" :checked.sync="fields_data.multiple_language" />


        </div>
      </CCol>
        <CCol col="12">
            <CRow >
                <CCol col="4" v-for="per in permissions">
                    <CRow style="background: white;margin: 5px;padding: 4px;border-radius: 4px">
                        <CCol col="9">
                            <p>{{per.desc}}</p>

                        </CCol>
                        <CCol col="3">
                            <input type="checkbox"
                                   v-model="per.value"/>
                        </CCol>
                    </CRow>

                </CCol>
            </CRow>
        </CCol>
        <CButton color="primary" @click="generate_config()">Generate</CButton>
    </CRow>
  </CContainer>
</template>

<script>


export default {
  name: 'Page500',
  props: {
  },
  components: {

  },
  data() {
    return {
      fields_data: {
          "website_address": "http://localhost:8080",
          "api_address": "https://mafoodsdb.nyxbit.com",
          "api_address3": "https://ueadb.ibsteam.co",
          "api_address2": "https://dbtest.chasbo.ir",
          "api_address1": "https://localhost:44321",
          "app_name": "company",
          "currency": "Dollar",
          "weight": "gr",
          "language": "fa",
          "language_fallback": "fa",
          "multiple_language": true,
          "footer_text_right": "IBS Team",
          "footer_text_left": "V 3.0.0",
          "footer_image": "/ibs_footer.png",
      },
        permissions: [
            {name:"sell_supplier_direct",value: true,desc:"فروش مستقیم تامین کننده"},
            {name:"sell_method",value: true,desc:"متد های فروش"},
            {name:"customer_type",value: true,desc:"نوع مشتری (Guild Type)"},
            {name:"help",value: true,desc:"تب help"},
            {name:"messages",value: true,desc:"تنظیمات پیام ها"},
            {name:"delivery_tracking",value: true,desc:"tracking در ساید بار"},
            {name:"reminder",value: true,desc:"ریمایندر"},
            {name:"cartable",value: true,desc:"کارتابل"},
            {name:"sell_program",value: true,desc:"برنامه فروش (Sales plan)"},
            {name:"cost_centers",value: true,desc:"Cost Center"},
            {name:"default_accounts",value: true,desc:"Period Report ,Default Accounts,Detail Accounting Docs "},
            {name:"driver_products",value: true,desc:"فروش مستقیم (کالاهای در راه)"},
            {name:"login_image",value: true,desc:"نمایش لوگو در لاگین"},
            {name:"journal",value: true,desc:"journal"},
            {name:"buyCurrency",value: true,desc:"خرید ارزی"},
            {name:"personals_payroll",value: true,desc:"Payroll حقوق"},
           { name:"personals_report",value: true,desc:"گزارش حقوق"},
            {name:"administrative_persons",value: true,desc:"Administrative Persons"},
            {name:"company_chart",value: true,desc:"طراحی سازمان Company Chart"},
            {name:"delivery",value: true,desc:"delivery سایدبار تحویل"},
            {name:"merge_price_result",value: true,desc:"Merge Price Result"},
            {name:"setting_accounts",value: true,desc:"گزارشات حسابداری در گزارشات و تنظیمات حسابداری در تنظیمات"},
            {name:"chart_of_account",value: true,desc:"Chart of Account لیست حساب ها"},
            {name:"account_circulation",value: true,desc:"Account Turnover گردش حساب"},
            {name:"finance_report",value: true,desc:"Financial Report گزارش مالی"},
            {name:"bank_diffrence",value: true,desc:"گزارش مغایرت بانکی Bank Discrepancy"},
            {name:"AllReports",value: true,desc:"سایدبار گزارشات"},
            {name:"pay_receive_report",value: true,desc:"دریافت و پرداخت در گزارشات"},
            {name:"period_report",value: true,desc:"گزارش مالی دوره زمانی Debtor Ageing Report"},
            {name:"auto_accounting",value: true,desc:"تیک Auto Accounting سند اتوماتیک"},
            {name:"negative_stock",value: true,desc:"فروش در موجودی منفی"},
            {name:"product_guild_price",value: true,desc:"قیمت های تایپ مشتری"},
            {name:"multi_factor_finalize",value: true,desc:"نهایی کردن چند فاکتوری"},
            {name:"delivery_report_baigani",value: true,desc:"لیست بایگانی در تحویل"},
            {name:"buy_operation",value: true,desc:"عملیات خرید"},
           { name:"payroll",value: true,desc:"payroll در سایدبار"},
            {name:"inventory_coding",value: true,desc:"کدینگ کالا Inventory Coding"},
            {name:"main_group",value: true,desc:"گروه اصلی Main Group"},
            {name:"job_unit",value: true,desc:"companyChart در cost center"},
            {name:"branch",value: true,desc:"Branch"},
            {name:"country",value: true,desc:"کشور"},
            {name:"county",value: true,desc:"استان"},
            {name:"accounting_groups",value: true,desc:"Accounts Group در تنظیمات حسابداری"},
            {name:"persons_in_turnover",value: true,desc:"اشخاص در turnover"},
            {name:"minFactorPrice",value: true,desc:"حداقل قیمت در فاکتور"},
            {name:"warehouse_output",value: true,desc:"خروج از انبار Warehouse Output"},
            {name:"header_view",value: true,desc:"View nv هدر"},
            {name:"print_factor_description",value: true,desc:"پرینت توضیحات در فاکتور"},
            {name:"jashnvare",value: true,desc:"جشنواره"},
            {name:"a4_print",value: true,desc:"پرینت A4"},
            {name:"visitor_porsant",value: true,desc:"پورسانت ویزیتور"},
            {name:"sale_hide_tax_off",value: false,desc:"مخفی کردن مالیات در فاکتور فروش"},
            {name:"all_factor_nesie",value: false,desc:"همه فاکتور ها نسیه ثبت شوند"},
            {name:"pos_print_document",value: false,desc:"فیش پرینتر در نمایش سند"},
            {name:"document_payment_info",value: false,desc:"اطلاعات پرداخت درون فاکتور"},
            {name:"document_save_print",value: false,desc:"دکمه ذخیره و پرینت درون فاکتور"},
            {name:"document_email",value: false,desc:"دکمه ایمیل درون فاکتور"},
            {name:"document_print_full",value: false,desc:"پرینت کامل درون فاکتور"},
            {name:"document_print_low",value: false,desc:"پرینت کم درون فاکتور"},



        ]
    }
  },
  mounted() {

  },
  watch: {},
  methods: {

      generate_config(){
          var pers = {};
          this.permissions.forEach(function (val) {
              pers[val.name]=val.value
          })
          this.fields_data.permissions = pers
          const link = document.createElement("a");

// Create a blog object with the file content which you want to add to the file
          const file = new Blob([JSON.stringify(this.fields_data)], { type: 'text/plain' });

// Add file content in the object URL
          link.href = URL.createObjectURL(file);

// Add file name
          link.download = "x_config.json";

// Add click event to <a> tag to save file.
          link.click();
          URL.revokeObjectURL(link.href);
      }
  }
}

</script>
